import React, { useEffect } from "react";
import { Header, Footer, LeftMenu } from "../commons/components";
import { Content } from "./components";
import { usePageSettingHeaderStore } from "../commons/stores";

export default function Home() {
  const [statePageSettingHeader] = usePageSettingHeaderStore();

  useEffect(() => {
    document.title = `User Management - Ubaform Admin`;
  }, []);

  return (
    <div className="App">
      <Header />
      {statePageSettingHeader.leftMenu ? <LeftMenu /> : null}

      <main className="workspace">
        <Content />

        <Footer />
      </main>
    </div>
  );
}
